import styled, { css } from 'styled-components'

import { PageBlock, BlockContent } from 'components/layout'
import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Container = styled(PageBlock)`
  color: ${({ theme }) => theme.colors.white};
  padding: 65px;

  ${mediaQueries.mobile`
    padding: 20px;
  `}

  ${({ simplifiedMobile }) =>
    simplifiedMobile &&
    `
    padding: 23px;
  `};
`
export const Title = styled.label.attrs(() => ({
  className: e2eClasses('helpCenter.helpTitle')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 24px;
  margin-bottom: 8px;
  text-align: center;
`

export const TitleSimplified = styled.div.attrs(() => ({
  className: e2eClasses('helpCenter.helpTitle')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.blue};
  margin-bottom: 27px;
`

export const Subtitle = styled.label.attrs(() => ({
  className: e2eClasses('helpCenter.helpSubtitle')
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  margin-bottom: 70px;
  text-align: center;
`

export const Row = styled(BlockContent)`
  display: flex;
  width: 100%;
  justify-content: center;

  ${mediaQueries.mobile`
    display: block;
  `};
`
export const Column = styled.div.attrs(() => ({
  className: e2eClasses('helpCenter.helpColumn')
}))`
  text-align: center;
  display: block;
  flex: 1;
  margin-bottom: 20px;
  ${({ simplifiedMobile }) =>
    simplifiedMobile &&
    ` 
      display: flex;
      flex-direction: row;
      align-items: center;
    `};
`
export const ColumnMobileSimplified = styled.div`
  ${({ simplifiedMobile }) =>
    simplifiedMobile &&
    ` 
    display: flex;
    flex-direction: column;
    text-align: start;
    padding-left: 23px;
  `};
`
export const TableHeader = styled.a.attrs(() => ({
  className: e2eClasses('helpCenter.helpItem')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-decoration: underline;
  font-size: 18px;
  margin-top: 0;
  color: ${({ simplified, theme }) => (simplified ? theme.colors.doveGray : theme.colors.white)};
  padding-bottom: ${({ simplified }) => (simplified ? `15px` : `30px`)};
  display: block;

  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
  ${mediaQueries.mobile`
    ${({ simplified }) =>
      simplified &&
      `
      text-decoration: none;
      font-size: 16px;
    `}
 `};
`
export const TableBody = styled.nav`
  min-height: 50px;
`
export const Link = styled.a.attrs(() => ({
  className: e2eClasses('helpCenter.helpSubItem')
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  display: block;
  color: ${({ simplified, theme }) => (simplified ? theme.colors.doveGray : theme.colors.white)};
  text-decoration: none;
  &:hover {
    font-family: ${({ theme, href }) => (href ? theme.fonts.semiBold : theme.fonts.regular)};
  }
  ${mediaQueries.mobile`
    ${({ simplified, theme }) =>
      simplified &&
      ` 
      color: ${theme.colors.blue};
      text-decoration: underline;
      font-size: 14px;
      margin-bottom: 5px;
    `};
  `};
`
export const IconWrapper = styled.div.attrs(() => ({
  className: e2eClasses('helpCenter.helpIcon')
}))`
  padding-bottom: 10px;
`

export const HelpCenterWrapper = styled.div.attrs(() => ({
  className: e2eClasses('helpCenter.helpBox')
}))`
  padding-top: 50px;
`

export const Header = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.blue};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 15px;
  border-bottom: solid 1px ${({ theme }) => theme.colors.white};

  ${mediaQueries.tablet`
    padding: 15px 65px;
  `};

  ${mediaQueries.mobile`
    padding: 8px 20px;
  `};
`

export const Content = styled.div`
  display: none;

  ${mediaQueries.tablet`
    flex-direction: column;
    padding: 35px 65px 0;
  `};

  ${mediaQueries.mobile`
    padding: 35px 20px 0;
  `};

  ${props =>
    props.isExpanded &&
    css`
      justify-content: space-between;
      padding: 35px 0 0;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    `};
`

export const Image = styled.img`
  height: 35px;
  width: 35px;
  filter: grayscale(100%);
`
